import React, { useState } from "react";
import { FaFileSignature } from "react-icons/fa";
import { listFinalists } from "./aiHireApi";
import CandidateDrawer from "./CandidateDrawer";
import { AiScoreBadge, EmptyRow, PreviewButton, Tone, fmtCtc, fmtDate, useAiHireData } from "./AiHireUi";

const approvalTone = (approval) => (approval.startsWith("Approved") ? "green" : "amber");

/** Finalized Candidates: interview scorecards done; waiting for owner / hiring manager approval and the offer. */
function FinalizedCandidatesTab() {
  const finalists = useAiHireData(listFinalists, []);
  const [open, setOpen] = useState(null);

  return (
    <div className="aihire-tab">
      <p className="aihire-muted">
        Candidates who cleared every interview round. The hiring manager or owner approves, then the recruiter
        releases the offer.
      </p>
      <div className="aihire-table-wrap">
        <table className="aihire-table">
          <thead>
            <tr>
              <th>Candidate</th>
              <th>Job</th>
              <th>Client / Project</th>
              <th>Scorecards</th>
              <th>AI score</th>
              <th>Decision</th>
              <th className="num">Expected</th>
              <th className="num">Proposed</th>
              <th>Can join</th>
              <th>Approval</th>
              <th aria-label="Actions" />
            </tr>
          </thead>
          <tbody>
            {finalists && finalists.length === 0 ? <EmptyRow colSpan={11}>No finalized candidates yet.</EmptyRow> : null}
            {(finalists || []).map((f) => (
              <tr key={f.id}>
                <td>
                  <button type="button" className="aihire-link" onClick={() => setOpen(f)}>
                    {f.candidate.name}
                  </button>
                </td>
                <td>{f.job.title}</td>
                <td>
                  {f.job.client} / {f.job.project}
                </td>
                <td>
                  {f.scorecards.map((s) => (
                    <span key={s.round} className="aihire-scorecard" title={`Rated by ${s.by}`}>
                      {s.round} <b>{s.rating}/5</b>
                    </span>
                  ))}
                </td>
                <td>
                  <AiScoreBadge score={f.aiInterview?.score} recommendation={f.aiInterview?.recommendation} />
                </td>
                <td>
                  <Tone tone="green">{f.decision}</Tone>
                </td>
                <td className="num">{fmtCtc(f.expectedCtc)}</td>
                <td className="num">{fmtCtc(f.proposedCtc)}</td>
                <td>{fmtDate(f.canJoin)}</td>
                <td>
                  <Tone tone={approvalTone(f.approval)}>{f.approval}</Tone>
                </td>
                <td>
                  <PreviewButton icon={FaFileSignature} primary small>
                    Release offer
                  </PreviewButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {open ? <CandidateDrawer app={open} onClose={() => setOpen(null)} /> : null}
    </div>
  );
}

export default FinalizedCandidatesTab;
